import type User from 'types/models/user';

import parseBackendPhoneNumber from './parse-backend-phone-number';

/**
 * Parses both mobile and landline phone numbers for a User object.
 * Returns a new object with formatted phone fields.
 */
export default function parseUserPhones(user: User): User {
  let parsed = parseBackendPhoneNumber(
    user,
    'mobileNumber',
    'mobileNumberCountryCode',
    'mobileNumberFormatted'
  );
  parsed = parseBackendPhoneNumber(
    parsed,
    'landlineNumber',
    'landlineNumberCountryCode',
    'landlineNumberFormatted'
  );
  return parsed;
}
